<template>
  <v-container>
    <v-main>
        <v-img
          src="https://itsasmileworld.com/wp-content/uploads/2020/03/Its-a-smile-world-header-logo-300x300-1.png"
          class="my-3"
          contain
          height="200"
        />


      <AdminTable/>
    </v-main>
  </v-container>
</template>

<script>
import AdminTable from '../components/AdminTable.vue';

export default {
  name: 'AdminTableScreen',

  components: {
    AdminTable,
  },
  data: () => ({
    //
  }),
};
</script>
